const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Checks if the given date is within one week from now.
 * Used to determine if "new" badge should be shown for recently updated items.
 *
 * @param dateString - ISO date string to check
 * @returns true if the date is within the last 7 days, false otherwise
 */
export default function isWithinOneWeek(
  dateString: string | null | undefined,
): boolean {
  if (!dateString) return false;

  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();

    // Check if the date is in the past and within one week
    return diffMs >= 0 && diffMs <= ONE_WEEK_MS;
  } catch {
    return false;
  }
}
